import { decamelizeKeys } from 'humps'
import { ENDPOINTS } from 'utils/api/callApi'
import { SHIPMENT_STATS_MAP, SHIPMENT_TABS } from '../../constants/shipments'

export const SHIPMENT_STATS_ACTION_TYPES = {
  STATS_REQUEST: 'STATS_REQUEST',
  STATS_SUCCESS: 'STATS_SUCCESS',
  STATS_FAILURE: 'STATS_FAILURE',
}
export const SELECT_STAT = 'SELECT_STAT'

export const getShipmentCounts = (params = {}) => {
  const body = {
    filters: decamelizeKeys({ ...params }),
  }
  return {
    payload: {
      callApi: true,
      requestData: {
        // This endpoint ignores status, stateOptions and pickup/delivery date params
        endpoint: ENDPOINTS.shipments,
        group: 'quick_filters_count',
        method: 'POST',
        body,
      },
      actionTypes: Object.keys(SHIPMENT_STATS_ACTION_TYPES),
    },
  }
}
export const selectStat = (key = '', dateLabel = '', shipmentFilters = {}) => {
  // Doesn't do much for now.  WIP
  const { selectedTabIndex = 2, statType = 'today' } = shipmentFilters
  const { statsKey } = SHIPMENT_TABS[selectedTabIndex]
  const selectedStat = SHIPMENT_STATS_MAP[statsKey][statType].find(s => s.key === key) || {}
  const filters = { ...selectedStat.filters }
  return {
    payload: { key, dateLabel, filters },
    type: SELECT_STAT,
  }
}
